import { render, staticRenderFns } from "./Sonac.vue?vue&type=template&id=2eaad732&scoped=true"
import script from "./Sonac.vue?vue&type=script&lang=js"
export * from "./Sonac.vue?vue&type=script&lang=js"
import style0 from "./Sonac.vue?vue&type=style&index=0&id=2eaad732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaad732",
  null
  
)

export default component.exports